import { ReactNode, useCallback, useMemo } from 'react';
import { useHistory } from 'react-router-dom';

import { TFunction } from 'Modules/core/i18n';


export const MOBILE_WIDTH = 480;

export const useRegistrationNavigate = () => {
    const { push } = useHistory();
    return useCallback(() => push('/onboarding'), [push]);
};

export const useNavigate = (route, state = {}) => {
    const { push } = useHistory();
    return useCallback(() => push(route, state), [push, route, state]);
};

export const navigateExternal = link => Object.assign(document.createElement('a'), {
    target: '_blank',
    rel: 'noopener norefferer',
    href: link,
}).click();

export const getIdFromAnchor = anchor => anchor.replace('#', '');

export type ListForTranslate<T> = Array<Omit<T, 'label'> & {tKey: string}>
export const useListTranslate = <T extends {label: ReactNode}>
(t: TFunction, list: ListForTranslate<T>) =>
    useMemo(() => list.map(
        ({ tKey, ...el }) => ({
            ...el,
            label: t(tKey),
        }),
    ), [t, list]);
